import { utils, BigNumber } from "ethers"

interface Props {
  startPriceWei: BigNumber
  currentPriceWei: BigNumber
  endPriceWei: BigNumber
  currencySymbol: string
}

const MintingPrice = ({ startPriceWei, currentPriceWei, endPriceWei, currencySymbol }: Props) => {
  const fixedPrice = startPriceWei.eq(endPriceWei)
  const startToEnd = Number(startPriceWei.toBigInt() - endPriceWei.toBigInt())
  const startToCurrent = Number(startPriceWei.toBigInt() - currentPriceWei.toBigInt())
  const pct = fixedPrice ? 0 : (startToCurrent / startToEnd) * 100

  return (
    <div className="mb-6">
      {fixedPrice ? (
        <p className="text-sm font-medium text-gallery-text">
          {utils.formatEther(startPriceWei.toString())} {currencySymbol}
        </p>
      ) : (
        <>
          <p className="gallery-label text-gallery-muted mb-2">Auction Price ({currencySymbol})</p>
          <div className="flex justify-between text-sm mb-1">
            <span>{utils.formatEther(startPriceWei.toString())}</span>
            <span>{utils.formatEther(endPriceWei.toString())}</span>
          </div>
          <div className="h-0.5 bg-gallery-border rounded-full overflow-hidden">
            <div className="h-full bg-gallery-text rounded-full" style={{ width: `${pct}%` }} />
          </div>
        </>
      )}
    </div>
  )
}

export default MintingPrice
